const urlName = '/raas/course/v1'
export default API => ({
    // 课程授权--列表
    getGrantList(data,params) {
        return API({ url: `${urlName}/courseGrant/findCourseGrantList?pageNum=${params.pageNum}&pageSize=${params.pageSize}`, method:  'post',  data})
    },
    getCourseGrantList(params) {
        return API({ url: `${urlName}/course/findValidCourseList?${params}`, method:  'get'})
    },
    // 获取客户信息
    getCoustomerList(params) {
        return API({ url: `/usercenter/v1/saas/getAll?${params}`})
    },
    // 课程授权--授权
    courseGrant(data) {
        return API({ url: `${urlName}/courseGrant/batchGrant`, method:  'post',  data})
    },
    // 根据客户获取分校信息
    getBranchByCoustomer(params) {
        return API({ url: `/usercenter/v1/branch/getBranchTreeBySaasId?saasId=${params}`, method:'get'})
    },
    // 授权记录   课程授权
    batchGrantTime(data){
        return API({ url: `${urlName}/courseGrant/batchGrantTime`, method:  'post',  data})
    },
    // 授权记录   课程续时
    batchExtendTime(data){
        return API({ url: `${urlName}/courseGrant/batchExtendTime`, method:  'post',  data})
    }
})
